import { inject, Injectable, signal } from '@angular/core';
import { ApiGatewayService, SakooResponse } from './api-gateway.service';
import { Observable, map, tap } from 'rxjs';

export interface Currency {
  id: number;
  code: string;
  name: string;
  display_order: number;
  created_at: string;
  updated_at: string;
}

@Injectable({
  providedIn: 'root',
})
export class CatalogService {
  private readonly api = inject(ApiGatewayService);

  // Signal reactivo con el catálogo de monedas
  private readonly _currencies = signal<Currency[]>([]);
  public readonly currencies = this._currencies.asReadonly();

  /**
   * Obtiene el catálogo de monedas disponibles.
   * Actualiza el Signal interno y devuelve la lista ordenada por display_order.
   */
  getCurrencies(): Observable<Currency[]> {
    return this.api.get<SakooResponse<Currency[]>>('/api/v1/catalogs/currencies').pipe(
      map((res) => {
        if (res.code !== 1000) {
          throw new Error(res.message || 'Error al obtener el catálogo de monedas.');
        }
        return [...res.data].sort((a, b) => a.display_order - b.display_order);
      }),
      tap((data) => {
        this._currencies.set(data);
      })
    );
  }
}
